import {
  AccidentIssueWithCache,
  AccidentIssueWithCacheAnyoneInjuredEnum,
  AccidentIssueWithCacheMedicalNeededEnum,
  AccidentIssueWithCacheWasCrewInvolvedEnum,
} from '@/models/gen/graphql';
import { DATE_FE_FORMAT, TIME_FORMAT } from '@/constants';
import { ForwardRefExoticComponent, forwardRef } from 'react';

import { Datetime } from '@/utils';
import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { useAccidentHistoryDrawer } from '@/features/AccidentHistory/components/AccidentHistoryDrawer';
import { useProvider } from '@/common/Provider';

const AccidentFormHistoryTableRow = ({ id }: { id: string }, ref: ForwardRefExoticComponent<HTMLDivElement>): JSX.Element => {
  const [[accident], , { onEditAccident }] = useProvider<
    { data: Map<string, AccidentIssueWithCache>; driverFirstName: string; driverLastName: string; vehicleTrackingId: string },
    [AccidentIssueWithCache, string, string, string],
    { onEditAccident: (accident: AccidentIssueWithCache) => void }
  >(({ data: accidents, driverFirstName, driverLastName, vehicleTrackingId }) => [
    accidents.get(id) || ({} as AccidentIssueWithCache),
    driverFirstName,
    driverLastName,
    vehicleTrackingId,
  ]);
  const [state, setAccidentHistoryDrawer] = useAccidentHistoryDrawer(({ state, setState }) => [state, setState]);

  const onEdit = (): void => {
    if (onEditAccident) return onEditAccident(accident);
    setAccidentHistoryDrawer((current) => ({
      ...current,
      show: true,
      data: accident,
    }));
  };

  const isCrewInjured =
    accident.wasCrewInvolved === AccidentIssueWithCacheWasCrewInvolvedEnum.Yes &&
    accident.anyoneInjured === AccidentIssueWithCacheAnyoneInjuredEnum.Yes
      ? 'Crew Injured'
      : undefined;
  const isMedicalNeeded = accident.medicalNeeded === AccidentIssueWithCacheMedicalNeededEnum.Yes ? 'Medical Attention Needed' : undefined;

  return (
    <SimpleTableRow id={id} onDoubleClick={onEdit} ref={ref} visible>
      <SimpleTableCell name="ACCIDENT" className="w-md-grow">
        <span>
          {[accident.driverFirstName, accident.driverLastName].join(' ')} - #{accident.vehicleTrackingId}
        </span>
        <span>{[isCrewInjured, isMedicalNeeded].filter(Boolean).join(' - ')}</span>
      </SimpleTableCell>
      <SimpleTableCell name="CREATED_AT">
        <span>{new Datetime(accident.createdAt).format(DATE_FE_FORMAT)}</span>
        <span>{new Datetime(accident.createdAt).format(TIME_FORMAT)}</span>
      </SimpleTableCell>
    </SimpleTableRow>
  );
};

export default forwardRef(AccidentFormHistoryTableRow);
